import React from 'react';

export const CourseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M0 3C0 1.90625 0.875 1 2 1H14C15.0938 1 16 1.90625 16 3V13C16 14.125 15.0938 15 14 15H2C0.875 15 0 14.125 0 13V3ZM1.5 11.5V12.5C1.5 12.7812 1.71875 13 2 13H3C3.25 13 3.5 12.7812 3.5 12.5V11.5C3.5 11.25 3.25 11 3 11H2C1.71875 11 1.5 11.25 1.5 11.5ZM13 11C12.7188 11 12.5 11.25 12.5 11.5V12.5C12.5 12.7812 12.7188 13 13 13H14C14.25 13 14.5 12.7812 14.5 12.5V11.5C14.5 11.25 14.25 11 14 11H13ZM1.5 7.5V8.5C1.5 8.78125 1.71875 9 2 9H3C3.25 9 3.5 8.78125 3.5 8.5V7.5C3.5 7.25 3.25 7 3 7H2C1.71875 7 1.5 7.25 1.5 7.5ZM13 7C12.7188 7 12.5 7.25 12.5 7.5V8.5C12.5 8.78125 12.7188 9 13 9H14C14.25 9 14.5 8.78125 14.5 8.5V7.5C14.5 7.25 14.25 7 14 7H13ZM1.5 3.5V4.5C1.5 4.78125 1.71875 5 2 5H3C3.25 5 3.5 4.78125 3.5 4.5V3.5C3.5 3.25 3.25 3 3 3H2C1.71875 3 1.5 3.25 1.5 3.5ZM13 3C12.7188 3 12.5 3.25 12.5 3.5V4.5C12.5 4.78125 12.7188 5 13 5H14C14.25 5 14.5 4.78125 14.5 4.5V3.5C14.5 3.25 14.25 3 14 3H13ZM5 4V6C5 6.5625 5.4375 7 6 7H10C10.5312 7 11 6.5625 11 6V4C11 3.46875 10.5312 3 10 3H6C5.4375 3 5 3.46875 5 4ZM6 9C5.4375 9 5 9.46875 5 10V12C5 12.5625 5.4375 13 6 13H10C10.5312 13 11 12.5625 11 12V10C11 9.46875 10.5312 9 10 9H6Z"
        fill="currentColor"
      />
    </svg>
  );
};
